import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import PreBookingCard from '../components/PreBookingCard';
import moment from 'moment';

import * as homeActions from '../actions/homeActions';
import * as pricingActions from '../actions/pricingActions';
import {getTimeDifference} from '../utils/dates';
import { getEndDateFromStartDateAndDurationUnit } from '../utils/dates';
import { getDurationUnits } from '../utils/durationUnits'
import getPortalLocData from '../config/loc';


export  class EditBookingTimeForm extends React.Component {
    constructor(props){
        super(props);
    }


    toggle() {      
        this.props.toggle();

    }

      handlerSubmit=()=>{
        this.props.pricingActions.SelectPricingModel(this.props.pricing.defaultPricingModel);
        this.toggle();
      }
      handlerPriceChange(){
        let { startDate, selectedLocationId, untilDate} = this.props.locationDetail;
        let reqeust = {
          locationId: selectedLocationId,
          startTime :startDate,
          duration: getTimeDifference(startDate,untilDate),
          durationUnit: 3,
          TariffGroupId: getPortalLocData().tarrifID,
          smsReminder: false,
          optionalServices: []
        };
        this.props.pricingActions.getPrice(reqeust);
      }




    render(){
        const {
            isOpen,
            isFetching,
            startDate,
            locationId,
            untilDate
        } = this.props;

        let{selectedOffering}=this.props.locationDetail;

        return(
            <Modal isOpen={isOpen}
                backdrop={"static"}
                className={"modalChangeVehicle"}
                toggle={() => this.toggle(!isOpen)}>
                    <ModalHeader toggle={() => this.toggle()}>Update Booking Time</ModalHeader>
                    <ModalBody>

                        <PreBookingCard
                            isNarrow={true}
                            isLoading={isFetching}
                            startDate={startDate}
                            untilDate={untilDate}
                            handleFromTimeChange={this.handlerFromTimeChange}
                            handleToTimeChange={this.handlerToTimeChange}
                            onSubmit={this.handlerSubmit}
                            locationId={locationId}
                            minimumDuration={getTimeDifference(startDate,untilDate)}
                            maximumDuration={selectedOffering.pricing.maximumDuration}
                            durationUnits={selectedOffering.pricing.durationUnits?selectedOffering.pricing.durationUnits:3}
                            offeringId={selectedOffering.id}
                            disabled={selectedOffering.type!=0}
                            />
                    </ModalBody>

                </Modal>
        );
    }
}
EditBookingTimeForm.propTypes={
    isOpen:PropTypes.bool.isRequired,
    isFetching:PropTypes.bool,
    startDate:PropTypes.string.isRequired,
    untilDate:PropTypes.string.isRequired,
    locationId:PropTypes.string.isRequired,
    toggle: PropTypes.func.isRequired,
    homeActions:PropTypes.object.isRequired,
    pricingActions:PropTypes.object.isRequired,
    pricing:PropTypes.object


}

function mapStateToProps(state) {
    return {
      locationDetail: state.locationDetail,
      pricing:state.pricing
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      homeActions: bindActionCreators(homeActions, dispatch),
      pricingActions: bindActionCreators(pricingActions, dispatch)
    };
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditBookingTimeForm);




// WEBPACK FOOTER //
// ./src/forms/EditBookingTimeForm.jsx